<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '840px'}"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-money-bill header-icon"></i>
        <h2>Rimodula l'importo richiesto per l'intervento</h2>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="summary-section p-3 mb-4" style="background-color: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
        <div class="grid">
          <div class="col-12">
            <div class="summary-card" style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; background: white; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
              <div style="text-align: center; flex: 1; ">
                <span class="summary-label" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.5rem;">Importo Totale RICHIESTO</span>
                <span class="summary-value" style="display: block; color: #30928b; font-size: 1.25rem; font-weight: 600;">€ {{ intervento?.richiesta?.importoRichiesto|  currency:'EUR':'':'1.2-2':'it-IT'  }}</span>
              </div>
              <div style="text-align: center; flex: 1; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6; padding: 0 1rem;">
                <span class="summary-label" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.5rem;">Importo Totale del CONTRIBUTO</span>
                <span class="summary-value" style="display: block; color: #175220; font-size: 1.25rem; font-weight: 600;">€ {{ intervento?.richiesta?.importoContributo|  currency:'EUR':'':'1.2-2':'it-IT'  }}</span>
              </div>

              <div style="text-align: center; flex: 1;">
                <span class="summary-label" style="display: block; color: #2b4a7a; font-size: 0.875rem; margin-bottom: 0.5rem;">Importo Totale RIMODULATO</span>
                <span class="summary-value" [ngStyle]="{'color': importoComplessivoRimodulato > (intervento?.richiesta?.importoContributo ?? 0) ? '#ff0000' : '#28a745', 'display': 'block', 'font-size': '1.25rem', 'font-weight': '600'}">€ {{ importoComplessivoRimodulato |  currency:'EUR':'':'1.2-2':'it-IT'  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 2rem;">
        <form [formGroup]="form">
          <div style="display: flex; gap: 2rem; align-items: center; justify-content: center; padding: 1rem;">
            <div style="width: 280px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
              <label for="importoRichiesto" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo RICHIESTO</label>
              <p-inputNumber
                id="importoRichiesto"
                formControlName="importoRichiesto"
                mode="currency"
                currency="EUR"
                locale="it-IT"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                styleClass="w-full"
                [style]="{'width': '100%'}">
              </p-inputNumber>
            </div>
            <div style="display: flex; align-items: center; color: #6c757d;">
              <i class="pi pi-arrow-right" style="font-size: 2rem;"></i>
            </div>
            <div style="width: 280px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
              <label for="importoContributo" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo RIMODULATO</label>
              <p-inputNumber
                id="importoRimodulato"
                formControlName="importoRimodulato"
                mode="currency"
                currency="EUR"
                locale="it-IT"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                styleClass="w-full"
                [style]="{'width': '100%'}">
              </p-inputNumber>
              <small *ngIf="importoComplessivoRimodulato > (intervento?.richiesta?.importoContributo ?? 0)" class="p-error" style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
                <i class="pi pi-exclamation-triangle"></i>
                L'importo rimodulato non può superare l'importo del contributo
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-primary"
        [disabled]="importoComplessivoRimodulato > (intervento?.richiesta?.importoContributo ?? 0)"
        (click)="conferma()">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
